import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from "react-redux";
import {Col, Row, Table} from 'reactstrap';

import Button from "../../components/button/button";
import FormSection from "../../components/form-section/form-section";
import LoadingSpinner from "../../components/loading-spinner/loading-spinner";
import PlayerDashboardButtons from "../../components/player-dashboard-buttons/player-dashboard-buttons";

import {getTeamMembers} from "../../../modules/user";
import {getOnePlayer, sharePlayer, cancelPlayerShare, getPlayerTeamMembers} from "../../../modules/player";
import {setPageTitle} from "../../../modules/application/pages";

import "./player-team-members.css";


class PlayerTeamMembers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            player: {},
            availableTeamMembers: [],
            assignedTeamMembers: [],
            gotPlayerInfo: false
        };

        this.onMoveTeamMember = this.onMoveTeamMember.bind(this);
        this.setPlayer = this.setPlayer.bind(this);
    }

    async componentDidMount() {
        const {user} = this.props;        
        const {id} = this.props.match.params;
        const {gotPlayerInfo} = this.state;

        if (!gotPlayerInfo) {
            let playerResponse = await getOnePlayer(id, user.token); 
            if (playerResponse.data && playerResponse.data.success && playerResponse.data.player_data) {
                let player = playerResponse.data.player_data;
                this.setState({ player: player, gotPlayerInfo: true});
                this.setPlayer(player.id);
            }           
        }
    }

    async componentDidUpdate() {
        const {user} = this.props;        
        const {id} = this.props.match.params;
        const {gotPlayerInfo} = this.state;

        if (!gotPlayerInfo) {
            let playerResponse = await getOnePlayer(id, user.token); 
            if (playerResponse.data && playerResponse.data.success && playerResponse.data.player_data) {
                let player = playerResponse.data.player_data;
                this.setState({ player: player, gotPlayerInfo: true});
                this.setPlayer(player.id);
            }           
        }
    }

    async setPlayer(playerId) {
        const {user} = this.props;
        const {player} = this.state;

        const teamMembersResponse = await getTeamMembers(user.token, false);

        let teamMembers = teamMembersResponse.data.team_members;

        const playerTeamMembersResponse = await getPlayerTeamMembers(playerId, user.token);

        let playerTeamMembers = playerTeamMembersResponse.data.player_team_members;

        let playerTeamMemberIDs = [];

        for (let i in playerTeamMembers) {
            let currentMember = playerTeamMembers[i];
            playerTeamMemberIDs.push(currentMember.id);
        }
        
        let ownerID = player.owner_id;
        let owner = {};
        for (let index in teamMembers) {
            let currentMember = teamMembers[index];
            if (currentMember.id === ownerID) {
                owner = currentMember;
            }
        }


        // const teamMembers = users.filter(user => {
        //     if (user.id === player.owner) {
        //         return false
        //     }
        //     return user.organizations && user.organizations.includes(organization)
        // });

        const assignedTeamMembers = teamMembers.filter(user => {
            return playerTeamMemberIDs && playerTeamMemberIDs.includes(user.id)
        });

        let availableTeamMembers = teamMembers.filter(user => {
            if (user.id === owner.id) {
                return false;
            }

            return !assignedTeamMembers.find(assigned => assigned.id === user.id)
        });


    

        //assignedTeamMembers.push(owner);

        this.setState({player, assignedTeamMembers, availableTeamMembers});
        this.props.dispatch(setPageTitle(player.name));
    }


    render() {
        return (
            <div className="px-1"><FormSection
                component={this.playerTeamMembers()}/></div>
        );
    }

    playerTeamMembers = () => {
        const {isTherapistRole} = this.props;
        const {player, assignedTeamMembers, availableTeamMembers} = this.state;

        const availableTeamMembersComponent = this.teamMembersComponent(assignedTeamMembers, player, null, true);
        const assignedTeamMembersComponent = this.teamMembersComponent(availableTeamMembers, player, null, false);

        const playerTeamMembers = <Row className="mp-0">
            {assignedTeamMembersComponent}
            {availableTeamMembersComponent}
        </Row>;

        return <div className="mp-0 container-fluid">
            <PlayerDashboardButtons player={player} activePage={"playerTeamMembers"} isTherapistRole={isTherapistRole} />
            <Col className="mp-0 text-left">
                <FormSection
                    sectionLabel="Manage Player Team Members"
                    component={
                        <div className="m-0 px-0 py-2 text-left container-fluid">
                            {playerTeamMembers}
                            {!player.id && <LoadingSpinner/>}
                        </div>
                    }/>
            </Col>
        </div>;
    };

    teamMembersComponent = (teamMembers, player, onMove, isAssigned) => {
        return <div className='mx-1'>
            <Table striped bordered className="m-1 p-0 Player-Team-Members-table">
                <thead>
                <tr className="pl-2 text-left">
                    <th className="m-0 p-0">
                        {isAssigned ? "Assigned" : "Available"} Team Members
                    </th>
                </tr>
                </thead>
                <tbody>
                {teamMembers && teamMembers.map(
                    teamMember => {
                        const isOwner = player.owner_id === teamMember.id;
                        return <tr className="text-left" title={""}>
                            <td className="m-1 p-1" style={{width: "100%"}}>
                                {teamMember.name} {isOwner && "(Owner)"}
                            </td>
                            <td className="my-auto mx-0 p-0">
                                <Button
                                    className="btn-sm"
                                    disabled={isOwner}
                                    text={isAssigned ? "Remove" : "Assign"}
                                    color={isAssigned ? "info" : "success"}
                                    onClick={() => {
                                        this.onMoveTeamMember(teamMember, player, !isAssigned)
                                    }}
                                />
                            </td>
                        </tr>
                    })
                }
                </tbody>
            </Table>
        </div>
    };

    async onMoveTeamMember(teamMember, player, isAssigned) {
        const {token} = this.props;
        let {assignedTeamMembers, availableTeamMembers} = this.state;
        
        const isFound = assignedTeamMembers && assignedTeamMembers.find(user => {
            return user.id === teamMember.id
        });

        if (!isAssigned && isFound) {
            assignedTeamMembers = assignedTeamMembers.filter(_teamMember => {
                return _teamMember.id !== teamMember.id
            });

            let cancelPlayerShareResponse = await cancelPlayerShare(player.id, teamMember.id, token);

            if (cancelPlayerShareResponse.data && cancelPlayerShareResponse.data.success) {
                availableTeamMembers.push(teamMember);
                assignedTeamMembers = assignedTeamMembers.filter(_teamMember => {
                    return _teamMember.id !== teamMember.id
                })
            }
            else {
                console.log("Failed to cancel player share");
            }
            
        } else if (isAssigned && !isFound) {            
            let sharePlayerResponse = await sharePlayer(player.id, teamMember.id, token);

            if (sharePlayerResponse.data && sharePlayerResponse.data.success) {
                assignedTeamMembers.push(teamMember);
                availableTeamMembers = availableTeamMembers.filter(_teamMember => {
                    return _teamMember.id !== teamMember.id
                })
            }
            else {
               console.log("Failed to share Player");
            }


          
        }

       // await getEntity(dispatch, updatePlayer(player.id, {team_members: team_members}));
        this.setState({assignedTeamMembers, availableTeamMembers});
        this.setPlayer(player.id);
    };
}

const withState = connect(state => {
    const {user, player} = state;

    return {
        user: user,
        player: player.specific_player,
        token: user.token,
        isTherapistRole: user.isTherapistRole,
    };
});

export default withRouter(withState(PlayerTeamMembers));



// WEBPACK FOOTER //
// ./src/components/containers/player-team-members/player-team-members.js